




















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import DistributorApi from '@/api/distributor/index'
import CustomForm from '@/components/custom-form/index.vue'
@Component({
  components: {
    CustomForm
  }
})
export default class DistributorSelect extends Vue {
  // 选择的商品Id
  @Prop({
    type: Array,
    default: () => {
      return []
    }
  })
  selectedItems!: string[]

  // 是否显示按钮
  @Prop({
    type: Boolean,
    default: true
  })
  showBtn!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  show!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  IsMultiple!: boolean

  @Watch('show')
  showChange(show) {
    this.modal1 = !this.modal1
  }

  modal1: boolean = false
  total: number = 0
  pageSize: number = 10
  pageIndex: number = 1
  data = []
  filters = [
    {
      label: '输入搜索：',
      type: 'input',
      props: {
        placeholder: '分销员姓名'
      },
      key: 'keyWord'
    },
    {
      label: '销售额',
      key: 'AmountDistributionMin',
      defaultValue: null,
      renderContent: (h, item, form) => {
        return h('input-number', {
          props: {
            value: form['AmountDistributionMin'],
            min: 0
          },
          style: {
            width: '100px'
          },
          on: {
            input: value => {
              form['AmountDistributionMin'] = value
            }
          }
        })
      }
    },
    {
      renderLine: (h, item, form) => {
        h = this.$createElement
        return h(
          'div',
          {
            class: {
              'ivu-form-item': true
            }
          },
          [
            h(
              'div',
              {
                class: {
                  'ivu-form-item-content': true
                }
              },
              [h('span', { ref: 'custom' }, '~')]
            )
          ]
        )
      }
    },
    {
      key: 'AmountDistributionMax',
      defaultValue: null,
      renderLine: (h, item, form) => {
        h = this.$createElement
        return h(
          'div',
          {
            class: {
              'ivu-form-item': true
            }
          },
          [
            h(
              'div',
              {
                class: {
                  'ivu-form-item-content': true
                }
              },
              [
                h('input-number', {
                  props: {
                    value: form['AmountDistributionMax'],
                    min: 0
                  },
                  style: {
                    width: '100px'
                  },
                  on: {
                    input: value => {
                      form['AmountDistributionMax'] = value
                    }
                  }
                })
              ]
            )
          ]
        )
      }
    }
  ]
  get columns() {
    var data: any[] = [
      {
        title: '姓名',
        key: 'name',
        align: 'center'
      },
      {
        title: '状态',
        key: 'reviewStatus',
        slot: 'reviewStatus'
      }
    ]
    if (this.IsMultiple) {
      data.splice(0, 0, {
        type: 'selection',
        width: 60,
        align: 'center'
      })
    }
    return data
  }
  async mounted() {}
  @Watch('modal1')
  modalShowChange(show) {
    if (show) this.submitFn()
  }

  submitFn() {
    let form: any = this.$refs.lineForm
    form.submit()
  }

  submitChange(form, valid) {
    console.log(form)
    if (valid) {
      this.pageIndex = 1
      this.loadGoodsList(form)
    }
  }

  async loadGoodsList(form?) {
    let Name = null
    let AmountDistributionMin = null
    let AmountDistributionMax = null
    let vm = this
    if (form) {
      Name = form['keyWord']
      AmountDistributionMin = form['AmountDistributionMin']
      AmountDistributionMax = form['AmountDistributionMax']
    }
    await DistributorApi.getdistributionList(
      vm.pageSize,
      vm.pageIndex,
      Name,
      1,
      undefined,
      undefined,
      AmountDistributionMin,
      AmountDistributionMax
    ).then(res => {
      // console.log("goods", res);
      vm.total = res.data.totalCount
      let result = []
      res.data.items.forEach(element => {
        element['_disabled'] =
          vm.selectedItems.findIndex(x => x == element.id) > -1
        result.push(element)
      })
      vm.data = result
    })
  }

  async onPageChange(pageIndex: number) {
    this.pageIndex = pageIndex
    await this.submitFn()
  }
  currentChange(currentRow, oldCurrentRow) {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', currentRow.id)
      this.modal1 = false
    }
  }
  ok() {
    this.$emit('on-change', (this.$refs.selection as any).getSelection())
    this.modal1 = false
  }

  cancel() {
    if (!this.IsMultiple) {
      this.$emit('on-row-selected', null)
    } else {
      this.$emit('on-change', [])
    }
    this.modal1 = false
  }
  reviewStatus(status) {
    switch (status) {
      case 0:
        return '未审核'
      case 1:
        return '已通过'
      case 2:
        return '未通过'
      default:
        return ''
    }
  }
}
